import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

export type DropdownValue<T> = {
  value: T;
  text: string;
  disabled?: boolean;
}

@Component({
  selector: 'user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.css']
})
export class UserSelectComponent<T> implements OnInit {
  @Input() values: Observable<DropdownValue<T>>;
  
  @Input() value!: T;
  @Output() valueChange = new EventEmitter<T>();
  @Input() placeholder: string;
  @Input() label: string | null = null;

  constructor() { }

  ngOnInit() {
  }

  onSelect(value: T) {
    this.value = value;
    this.valueChange.emit(value);
  }
}


